enum FetchStatus {
  Initial,
  Fetching,
  Complete,
  Error
}

export default FetchStatus
